// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1880f60c","667":"fab8bb3e","977":"698cf111"}[chunkId] + ".chunk.js";
};